/**
 * Hook to fetch Slack integration status
 */

import { useEffect, useState } from 'react';
import { getSlackStatus } from '../api/slackSettings';

export function useSlackStatus(brandId) {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    let cancelled = false;
    
    async function fetchStatus() {
      if (!brandId) {
        setLoading(false);
        return;
      }
      
      setLoading(true);
      setError(null);
      
      try {
        const s = await getSlackStatus(brandId);
        if (!cancelled) {
          setStatus(s);
        }
      } catch (e) {
        if (!cancelled) {
          setError(e.message);
          setStatus(null);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }
    
    fetchStatus();
    
    return () => {
      cancelled = true;
    };
  }, [brandId]);
  
  return { status, loading, error, refetch: () => {
    setLoading(true);
    getSlackStatus(brandId)
      .then(setStatus)
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }};
}

export default useSlackStatus;
